import { render, staticRenderFns } from "./channelDealerInfo.vue?vue&type=template&id=3f2a0e22&"
import script from "./channelDealerInfo.vue?vue&type=script&lang=js&"
export * from "./channelDealerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports